// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"311b9b69","453":"7c6f4c9b","455":"3f3418ec","977":"6681a79d"}[chunkId] + ".chunk.js";
};